import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.MobileAppDownload', {
    title: 'Download our mobile app',
    description:
        'Get notifications, submit and approve requests on the go.{br}Scan the QR code with your phone camera to start using the app now.',
});
